import { createVanIconComponent } from "./van"

const CommentCircleOutlined = createVanIconComponent("comment-circle-o")
export default CommentCircleOutlined
